// LAP-550 — Table commune pour MarketCard (factorise 5 duplications)
import React from 'react'
import { Box } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Delta from './Delta'
import { invTheme } from './theme'
import AddOpportunityAction from './AddOpportunityAction'

export default function MarketTable({ data = [], variationKey = 'variation_1d', maxHeight = 280, getOpportunityValues }) {
  return (
    <TableContainer sx={{ color: 'white', maxHeight }}>
      <Table>
        <TableBody
          sx={{
            'td,th': { color: 'white', border: 'none', padding: '6px 0px' },
            '&:last-child td': { paddingRight: 1 },
            '.MuiTableCell-root': { fontSize: 13 },
          }}
        >
          {data.map((item, index) => {
            const variation = item[variationKey]
            const up = (variation || 0) >= 0
            return (
              <TableRow
                key={index}
                sx={{
                  transition: 'background 150ms ease',
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.04)' },
                }}
              >
                <TableCell component="th" scope="row" sx={{ position: 'relative', pl: 1.5 }}>
                  <Box
                    sx={{
                      position: 'absolute',
                      left: 0,
                      top: '20%',
                      bottom: '20%',
                      width: 3,
                      borderRadius: 2,
                      backgroundColor: up ? invTheme.positive : invTheme.negative,
                    }}
                  />
                  <Box sx={{ fontWeight: 500 }}>{item.name}</Box>
                </TableCell>
                <TableCell align="right">
                  <Box sx={{ fontWeight: 600 }}>
                    {parseFloat(item.price).toFixed(2)}
                    <Box component="span" sx={{ fontSize: 10, ml: 0.5, color: 'rgba(255,255,255,0.5)' }}>
                      {item.symbol}
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align="right">
                  <Delta value={variation} unit="%" />
                </TableCell>
                {getOpportunityValues && (
                  <TableCell align="right" sx={{ width: 28, padding: '4px 0 !important' }}>
                    <AddOpportunityAction initialValues={getOpportunityValues(item)} />
                  </TableCell>
                )}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
